export const siteMapData = [
    {
        id: "166",
        title: "IPS Deficiencies Report",
        label: "IPS Deficiencies Report",
        value: "public/ips-deficiencies",
        accessType: "public",
        roles: "",
        moduleCode: "",
    },
    {
        id: "167",
        title: "Request Portal Access",
        label: "Request Portal Access",
        value: "public/request-portal-access",
        accessType: "public",
        roles: "",
        moduleCode: "",
    },
    {
        id: "165",
        title: "Lead in School - Data",
        label: "Lead in School - Data",
        value: "https://waterlink.utah.gov/public/dynreport/viewReport.html?reportKey=ddw_lead_school_data",
        accessType: "public-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "168",
        title: "Operator Certification Report (CEU and Course Details)",
        label: "Operator Certification Report (CEU and Course Details)",
        value: "https://waterlink.utah.gov/public/ceuReport.html",
        accessType: "public-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "4000",
        title: "Backflow Program Admin Report (CEU and Course Details)",
        label: "Backflow Program Admin Report (CEU and Course Details)",
        value: "https://waterlink.utah.gov/public/backflowCeuReport.html",
        accessType: "public-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "5000",
        title: "Consumer Confidence Report (CCR)",
        label: "Consumer Confidence Report (CCR)",
        value: "https://waterlink.utah.gov/public/ccrReport.html",
        accessType: "public-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "6000",
        title: "IPS Deficiencies",
        label: "IPS Deficiencies",
        value: "https://waterlink.utah.gov/public/publicIpsDeficiencyPoints.html",
        accessType: "public-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "7000",
        title: "LHD Positive Sample Report",
        label: "LHD Positive Sample Report",
        value: "https://waterlink.utah.gov/public/lhdPositiveReport.html",
        accessType: "public-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "8000",
        title: "Current Cross Connection Control Program Administrators",
        label: "Current Cross Connection Control Program Administrators",
        value: "https://waterlink.utah.gov/public/publicBackflow1.html",
        accessType: "public-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "9000",
        title: "Backflow Assembly Tester and Instructor Trainer/Proctor",
        label: "Backflow Assembly Tester and Instructor Trainer/Proctor",
        value: "https://waterlink.utah.gov/public/publicBackflow2n3.html",
        accessType: "public-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "10000",
        title: "Current Commercially Available Backflow Testers for the State of Utah",
        label: "Current Commercially Available Backflow Testers for the State of Utah",
        value: "https://waterlink.utah.gov/public/publicBackflowComm.html",
        accessType: "public-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "11",
        title: "Engineering All Projects By File Number",
        label: "Engineering All Projects By File Number",
        value: "https://waterlink.utah.gov/public/allProjectSoryByFileNumber.html",
        accessType: "public-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "12",
        title: "Engineering All Projects By Water System Name",
        label: "Engineering All Projects By Water System Name",
        value: "https://waterlink.utah.gov/public/allProjectSoryByWaterSystem.html",
        accessType: "public-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "13",
        title: "Chemical Analysis Report",
        label: "Chemical Analysis Report",
        value: "https://waterlink.utah.gov/public/chemicalAnalysisReport.html",
        accessType: "public-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "14",
        title: "Level 1 Assessment Questionnaire",
        label: "Level 1 Assessment Questionnaire",
        value: "https://waterlink.utah.gov/public/level1.html",
        accessType: "public-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "101",
        title: "Modules Portal, File Upload Management, Portal, Rules Enforcements",
        label: "Modules Portal, File Upload Management, Portal, Rules Enforcements",
        value: "secure/module-index",
        accessType: "secure",
        roles: "portal",
        moduleCode: "RAE",
    },
    {
        id: "102",
        title: "File Upload Management",
        label: "File Upload Management, Upload File, Get File Upload History",
        value: "ddw-admin/file-upload/file-upload-management",
        accessType: "secure",
        roles: "portal",
        moduleCode: "",
    },
    {
        id: "103",
        title: "Portal, File Upload Management",
        label: "Portal, File Upload Management",
        value: "secure/portal-index",
        accessType: "secure",
        roles: "portal",
        moduleCode: "PRTL",
    },
    {
        id: "104",
        title: "Statewide Performance Metrics, Enforcements, Active Systems, Under Enforcement, Previous Month Deficiencies and Enforcements, Previous Year Deficiencies and Enforcment, Active Significant Deficiencies, Resolved Significant Deficiencies",
        label: "Statewide Performance Metrics, Enforcements, Active Systems, Under Enforcement, Previous Month Deficiencies and Enforcements, Previous Year Deficiencies and Enforcment, Active Significant Deficiencies, Resolved Significant Deficiencies",
        value: "secure/enforcements-dashboard",
        accessType: "secure",
        roles: "",
        moduleCode: "",
    },
    {
        id: "105",
        title: "Worst 25 Reports",
        label: "Worst 25 Reports, Statewide Performance Metrics, Enforcements",
        value: "/secure/enforcements/worst-25-reports",
        accessType: "secure",
        roles: "",
        moduleCode: "",
    },
    {
        id: "0",
        title: "Engineering Manage Plan Review",
        label: "Engineering Manage Plan Review",
        value: "https://waterlink.utah.gov/secure/casper/engineering/planReview/managePlanReview.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "1",
        title: "Engineering Manage Plan Review, Plan Review Submittal Reports",
        label: "Engineering Manage Plan Review, Plan Review Submittal Reports",
        value: "https://waterlink.utah.gov/secure/casper/engineering/planReview/engineerPlanReviewReport.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "2",
        title: "Engineering Manage Plan Review, Approved PWS Water Line Standards",
        label: "Engineering Manage Plan Review, Approved PWS Water Line Standards",
        value: "https://waterlink.utah.gov/secure/casper/engineering/planReview/waiversAandBReport.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "3",
        title: "Engineering Manage Plan Review, Hydraulic Model Report Waiver",
        label: "Engineering Manage Plan Review, Hydraulic Model Report Waiver",
        value: "https://waterlink.utah.gov/secure/casper/engineering/planReview/waiverCReport.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "4",
        title: "Engineering Manage Plan Review, Success Management Report",
        label: "Engineering Manage Plan Review, Success Management Report",
        value: "https://waterlink.utah.gov/secure/casper/engineering/planReview/planReviewSuccessReport.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "5",
        title: "Engineering Manage Plan Review, Plan Review Search",
        label: "Engineering Manage Plan Review, Plan Review Search",
        value: "https://waterlink.utah.gov/secure/casper/engineering/planReview/planReviewSearchExt.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "206",
        title: "Engineering Facility Exemption Variance and Exception Tracking",
        label: "Engineering Facility Exemption Variance and Exception Tracking",
        value: "https://waterlink.utah.gov/secure/facilityExceptionVarianceSearch.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "207",
        title: "Engineering Facility Exemption Variance and Exception Tracking",
        label: "Engineering Facility Exemption Variance and Exception Tracking",
        value: "https://waterlink.utah.gov/secure/facilityExceptionVarianceSearch.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "208",
        title: "Engineering Facility Exemption Variance and Exception Tracking",
        label: "Engineering Facility Exemption Variance and Exception Tracking",
        value: "https://waterlink.utah.gov/secure/facilityExceptionVarianceSearch.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "8",
        title: "Engineering Manage New Source Review",
        label: "Engineering Manage New Source Review",
        value: "https://waterlink.utah.gov/secure/casper/engineering/newSourceReview/initManagement.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "210",
        title: "Engineering Manage Water Use Reporting",
        label: "Engineering Manage Water Use Reporting",
        value: "https://waterusereporting.deq.utah.gov/",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "9",
        title: "Engineering Fire Flow Tracking Water Systems",
        label: "Engineering Fire Flow Tracking Water Systems",
        value: "https://waterlink.utah.gov/secure/casper/fireAuthority/waterSystem.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "212",
        title: "Engineering Fire Flow Tracking Fire Authority",
        label: "Engineering Fire Flow Tracking Fire Authority",
        value: "https://waterlink.utah.gov/secure/casper/fireAuthority/fireAuthority.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "11",
        title: "Engineering Managers Section Manage Engineer",
        label: "Engineering Managers Section Manage Engineer",
        value: "https://waterlink.utah.gov/secure/admin/casper/manageEngineer.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "33",
        title: "Source Protection Tracking Manage Source Protection",
        label: "Source Protection Tracking Manage Source Protection",
        value: "https://waterlink.utah.gov/secure/casper/tracking/tracking.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "34",
        title: "Source Protection Documents Pending Review Report",
        label: "Source Protection Documents Pending Review Report",
        value: "https://waterlink.utah.gov/secure/casper/tracking/documentPendingReviewReport.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "35",
        title: "Source Protection Water Source Status Report",
        label: "Source Protection Water Source Status Report",
        value: "https://waterlink.utah.gov/secure/casper/tracking/facilityStatusReport.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "36",
        title: "Source Protection Annual EPA Report",
        label: "Source Protection Annual EPA Report",
        value: "https://waterlink.utah.gov/secure/casper/tracking/sourceTrackingAnnualEpaReport.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "37",
        title: "Source Protection SUCCESS Management Report",
        label: "Source Protection SUCCESS Management Report",
        value: "https://waterlink.utah.gov/secure/casper/tracking/successManagementReport.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "38",
        title: "Source Protection Report for Surveyors",
        label: "Source Protection Report for Surveyors",
        value: "https://waterlink.utah.gov/secure/casper/tracking/sourceProtectionReport.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "39",
        title: "Source Protection Tracking Facility Exceptions Same as in Engineering Page",
        label: "Source Protection Tracking Facility Exceptions Same as in Engineering Page",
        value: "https://waterlink.utah.gov/secure/facilityExceptions.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "6",
        title: "Source Protection Tracking Facility Exceptions",
        label: "Source Protection Tracking Facility Exceptions",
        value: "https://waterlink.utah.gov/secure/facilityExceptions.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "7",
        title: "Source Protection Tracking Facility Exceptions Search",
        label: "Source Protection Tracking Facility Exceptions Search",
        value: "https://waterlink.utah.gov/secure/facilityExceptionSearch.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "41",
        title: "Enforcements Section Enforcement Actions",
        label: "Enforcements Section Enforcement Actions",
        value: "https://enforcementactions.deq.utah.gov/",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "42",
        title: "Enforcements Section Selected Deficiency Report",
        label: "Enforcements Section Selected Deficiency Report",
        value: "https://waterlink.utah.gov/secure/reports/selectedDeficiency.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "43",
        title: "Enforcements Section Disaggregated IPS Summary Report",
        label: "Enforcements Section Disaggregated IPS Summary Report",
        value: "https://waterlink.utah.gov/secure/reports/disagIpsSummary.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "44",
        title: "Enforcements Section Worst 25 Reports",
        label: "Enforcements Section Worst 25 Reports",
        value: "https://waterlink.utah.gov/secure/reports/worst25Reports.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "45",
        title: "Enforcements Section Institutional System Reports",
        label: "Enforcements Section Institutional System Reports",
        value: "https://waterlink.utah.gov/secure/reports/institutionalSystemReport.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "48",
        title: "Enforcements Section Historical IPS Report",
        label: "Enforcements Section Historical IPS Report",
        value: "https://waterlink.utah.gov/secure/reports/historicalIpsReport.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "49",
        title: "Enforcements Section Violations Dispute Dashboard",
        label: "Enforcements Section Violations Dispute Dashboard",
        value: "https://waterlink.utah.gov/secure/admin/mailIpsViolationsDashboard.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "50",
        title: "Enforcements Section Dispute Violations Systems List",
        label: "Enforcements Section Dispute Violations Systems List",
        value: "https://waterlink.utah.gov/secure/admin/ipsVioAppealResolutionSystemList.html",
        accessType: "secure-external",
        roles: "portal",
        moduleCode: "",
    },
    {
        id: "51",
        title: "Enforcements Section Dispute Violations Resolution Dashboard",
        label: "Enforcements Section Dispute Violations Resolution Dashboard",
        value: "https://waterlink.utah.gov/secure/admin/ipsAppealDashboard.html",
        accessType: "secure-external",
        roles: "portal",
        moduleCode: "",
    },
    {
        id: "52",
        title: "Enforcements Section Enforcement Action Report No Date CSV",
        label: "Enforcements Section Enforcement Action Report No Date CSV",
        value: "https://waterlink.utah.gov/secure/dynreport/dtsDynRunReport.html?reportKey=enforcement_action_report_no_date&dynReportAction=csv",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "53",
        title: "Enforcements Section Enforcement Action Report With Date",
        label: "Enforcements Section Enforcement Action Report With Date",
        value: "https://waterlink.utah.gov/secure/dynreport/viewReport.html?reportKey=enforcement_action_report_with_date",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "54",
        title: "IPS Section Significant Deficiencies Report",
        label: "IPS Section Significant Deficiencies Report",
        value: "https://waterlink.utah.gov/secure/reports/significantDeficiencies.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "55",
        title: "IPS Section IPS Violation Points",
        label: "IPS Section IPS Violation Points",
        value: "https://waterlink.utah.gov/secure/admin/ipsViolationPointsIps2020.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "56",
        title: "IPS Section IPS Deficiency Points",
        label: "IPS Section IPS Deficiency Points",
        value: "https://waterlink.utah.gov/secure/admin/ipsDeficiencyPoints2020.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "57",
        title: "IPS Section IPS Group Deficiencies",
        label: "IPS Section IPS Group Deficiencies",
        value: "https://waterlink.utah.gov/secure/admin/ipsGroupsAdmin2020.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "58",
        title: "IPS Section IPS Deficiencies Resolution Admin",
        label: "IPS Section IPS Deficiencies Resolution Admin",
        value: "https://waterlink.utah.gov/secure/admin/ipsDefcyResolutionAdmin.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "59",
        title: "IPS Section Run FTF Violations",
        label: "IPS Section Run FTF Violations",
        value: "https://waterlink.utah.gov/secure/admin/ftfViolations.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "46",
        title: "IPS Ratings Update Water System Rating",
        label: "IPS Ratings Update Water System Rating",
        value: "https://waterlink.utah.gov/secure/reports/ipsUpdateRating.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "47",
        title: "IPS Ratings Rating Change Needed Report",
        label: "IPS Ratings Rating Change Needed Report",
        value: "https://waterlink.utah.gov/secure/reports/ipsChangeRatingNeeded.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "62",
        title: "IPS Ratings IPS Historical Rating Change Report",
        label: "IPS Ratings IPS Historical Rating Change Report",
        value: "https://waterlink.utah.gov/secure/reports/ipsHistoricalRating.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "63",
        title: "Tools Chlorine Report CSV Conversion Tool",
        label: "Tools Chlorine Report CSV Conversion Tool",
        value: "https://waterlink.utah.gov/secure/chlorineReportCsvConversion.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "64",
        title: "Rules Section RTCR Compliance Schedules",
        label: "Rules Section RTCR Compliance Schedules",
        value: "https://waterlink.utah.gov/secure/reports/management/rtcrComplianceSchedules.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "65",
        title: "Rules Section Ground Water Assessment Report CSV Export",
        label: "Rules Section Ground Water Assessment Report CSV Export",
        value: "https://waterlink.utah.gov/secure/reports/groundWaterAssessmentReport.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "66",
        title: "Rules Section Violations Report",
        label: "Rules Section Violations Report",
        value: "https://waterlink.utah.gov/secure/reports/management/violationsReport.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "67",
        title: "Rules Section Grouped Source Administration",
        label: "Rules Section Grouped Source Administration",
        value: "https://waterlink.utah.gov/secure/admin/groupedSourceAdmin.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "68",
        title: "Rules Section RTCR Level Two Assessments",
        label: "Rules Section RTCR Level Two Assessments",
        value: "https://waterlink.utah.gov/secure/reports/management/levelTwoEcoliViolations.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "69",
        title: "Rules Section Open Schedules for Analyte and Group",
        label: "Rules Section Open Schedules for Analyte and Group",
        value: "https://waterlink.utah.gov/secure/dynreport/viewReport.html?reportKey=rules_open_schedules_analyte",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "70",
        title: "Rules Section Manage Level 1 Assessment Questionnaire",
        label: "Rules Section Manage Level 1 Assessment Questionnaire",
        value: "https://waterlink.utah.gov/secure/admin/manageLv1Assessment.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "71",
        title: "Rules Section Level 1 Assessment Main",
        label: "Rules Section Level 1 Assessment Main",
        value: "https://waterlink.utah.gov/secure/admin/lv1AssessmentOperationMain.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "72",
        title: "Rules Section Level 1 Assessment Questionnaire",
        label: "Rules Section Level 1 Assessment Questionnaire",
        value: "https://waterlink.utah.gov/public/level1.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "73",
        title: "Rules Section Detailed TC Positive Results",
        label: "Rules Section Detailed TC Positive Results",
        value: "https://waterlink.utah.gov/secure/dynreport/viewReport.html?reportKey=rules_detailed_tc_positive_results",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "74",
        title: "Rules Section 4 Log Removal Systems CSV",
        label: "Rules Section 4 Log Removal Systems CSV",
        value: "https://waterlink.utah.gov/secure/dynreport/dtsDynRunReport.html?reportKey=rule_4_log_removal_systems&dynReportAction=csv",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "75",
        title: "Treatment Section Treatment: Bin Status Report",
        label: "Treatment Section Treatment: Bin Status Report",
        value: "https://waterlink.utah.gov/secure/dynreport/viewReport.html?reportKey=rules_treatment_bin_status_report",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "76",
        title: "Treatment Section Treatment: Locational Running Annual Average Report",
        label: "Treatment Section Treatment: Locational Running Annual Average Report",
        value: "https://waterlink.utah.gov/secure/dynreport/viewReport.html?reportKey=rules_locational_annual_avg_report",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "77",
        title: "Treatment Section Treatment: Distribution Residuals Report",
        label: "Treatment Section Treatment: Distribution Residuals Report",
        value: "https://waterlink.utah.gov/secure/dynreport/viewReport.html?reportKey=rules_distirubiton_residuals_report",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "78",
        title: "Treatment Section Treatment: Chlorine Residuals Report",
        label: "Treatment Section Treatment: Chlorine Residuals Report",
        value: "https://waterlink.utah.gov/secure/dynreport/viewReport.html?reportKey=chlorine_residuals_monitoring_report",
        accessType: "secure-external",
        roles: "portal",
        moduleCode: "",
    },
    {
        id: "79",
        title: "Treatment Section Treatment: Chlorine Residuals Report All PWS",
        label: "Treatment Section Treatment: Chlorine Residuals Report All PWS",
        value: "https://waterlink.utah.gov/secure/dynreport/viewReport.html?reportKey=chlorine_residuals_monitoring_all_pws",
        accessType: "secure-external",
        roles: "portal",
        moduleCode: "",
    },
    {
        id: "80",
        title: "Certification Management Operator Certification Management",
        label: "Certification Management Operator Certification Management",
        value: "https://waterlink.utah.gov/secure/operator/operatorSearchMain.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "81",
        title: "Certification Management Exam Management",
        label: "Certification Management Exam Management",
        value: "https://waterlink.utah.gov/secure/examManagement.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "82",
        title: "Certification Management OC Exam Locations",
        label: "Certification Management OC Exam Locations",
        value: "https://waterlink.utah.gov/secure/admin/ocExamLocationAdmin.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "83",
        title: "Certification Management CEU Categories",
        label: "Certification Management CEU Categories",
        value: "https://waterlink.utah.gov/secure/course/manageCeuCategories.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "84",
        title: "Certification Management CEU Instructors",
        label: "Certification Management CEU Instructors",
        value: "https://waterlink.utah.gov/secure/course/manageCeuInstructors.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "85",
        title: "Certification Management CEU Portal Course",
        label: "Certification Management CEU Portal Course",
        value: "https://waterlink.utah.gov/secure/managePortalCourse.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "86",
        title: "Certification Management CEU Search Students in Pending Courses",
        label: "Certification Management CEU Search Students in Pending Courses",
        value: "https://waterlink.utah.gov/secure/searchStudentsInPendingCourses.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "87",
        title: "Certification Management Manage Operator eDocs Folder Link",
        label: "Certification Management Manage Operator eDocs Folder Link",
        value: "https://waterlink.utah.gov/secure/cert/admin/operatorFolderLinks.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "89",
        title: "Certification Management System Certification Classification",
        label: "Certification Management System Certification Classification",
        value: "https://waterlink.utah.gov/secure/systemCert/systemCertClassification.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "90",
        title: "Certification Reports Exam CSV Report",
        label: "Certification Reports Exam CSV Report",
        value: "https://waterlink.utah.gov/secure/operatorReports/examCsvReport.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "91",
        title: "Certification Reports Course CSV Report",
        label: "Certification Reports Course CSV Report",
        value: "https://waterlink.utah.gov/secure/operatorReports/courseCsvReport.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "92",
        title: "Certification Reports Master Certified Operator Listing CSV",
        label: "Certification Reports Master Certified Operator Listing CSV",
        value: "https://waterlink.utah.gov/secure/operatorReports/certifiedOperatorMailingReportCsv.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "93",
        title: "Certification Reports Operator Certification Details By System",
        label: "Certification Reports Operator Certification Details By System",
        value: "https://waterlink.utah.gov/secure/operatorReports/operatorDetailsBySystem.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "94",
        title: "Certification Reports Operator Examination Report",
        label: "Certification Reports Operator Examination Report",
        value: "https://waterlink.utah.gov/secure/operatorReports/operatorExaminationReport.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "95",
        title: "Certification Reports Operator Record",
        label: "Certification Reports Operator Record",
        value: "https://waterlink.utah.gov/secure/operator/operatorPrint.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "97",
        title: "Certification Reports Water Operators by County Report",
        label: "Certification Reports Water Operators by County Report",
        value: "https://waterlink.utah.gov/secure/operatorReports/operatorInCountyReport.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "98",
        title: "Certification Reports Water Courses Report",
        label: "Certification Reports Water Courses Report",
        value: "https://waterlink.utah.gov/secure/operatorReports/waterCourseReport.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "276",
        title: "Certification Reports Water Specialists Report",
        label: "Certification Reports Water Specialists Report",
        value: "https://waterlink.utah.gov/secure/operatorReports/waterSpecialistsReport.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "277",
        title: "Certification Compliance Operator Certification Compliance Schedules",
        label: "Certification Compliance Operator Certification Compliance Schedules",
        value: "https://waterlink.utah.gov/secure/operatorReports/operatorCertificationComplianceSchedules.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "278",
        title: "Certification Compliance Operator Certification Compliance by System",
        label: "Certification Compliance Operator Certification Compliance by System",
        value: "https://waterlink.utah.gov/secure/operatorReports/operatorCertificationComplianceBySystem.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "88",
        title: "Certification Compliance PWS Requirement",
        label: "Certification Compliance PWS Requirement",
        value: "https://waterlink.utah.gov/secure/systemCert/pwsRequirement.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "280",
        title: "Certification Compliance System Certification Classification",
        label: "Certification Compliance System Certification Classification",
        value: "https://waterlink.utah.gov/secure/systemCert/systemCertClassification.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "96",
        title: "Certification Compliance System Without Operator Report",
        label: "Certification Compliance System Without Operator Report",
        value: "https://waterlink.utah.gov/secure/operatorReports/systemWithoutOperatorReport.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "100",
        title: "Backflow Management",
        label: "Backflow Management",
        value: "https://waterlink.utah.gov/secure/backflow/backflowSearchMain.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "101",
        title: "Backflow CEU Course Management",
        label: "Backflow CEU Course Management",
        value: "https://waterlink.utah.gov/secure/backflowCourses/backflowCeuCourseManagement.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "102",
        title: "Backflow Manage CEU Instructors",
        label: "Backflow Manage CEU Instructors",
        value: "https://waterlink.utah.gov/secure/course/manageCeuInstructors.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "103",
        title: "Backflow Technicians for Employer Report",
        label: "Backflow Technicians for Employer Report",
        value: "https://waterlink.utah.gov/secure/backflow/allEmployerReport.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "104",
        title: "Backflow Certified Backflow Technicians",
        label: "Backflow Certified Backflow Technicians",
        value: "https://waterlink.utah.gov/secure/backflow/certifiedBackflowTechniciansReport.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "105",
        title: "Backflow Current Cross Connection Control Program Administrators",
        label: "Backflow Current Cross Connection Control Program Administrators",
        value: "https://waterlink.utah.gov/public/publicBackflow1.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "106",
        title: "Backflow Assembly Tester and Instructor Trainer/Proctor",
        label: "Backflow Assembly Tester and Instructor Trainer/Proctor",
        value: "https://waterlink.utah.gov/public/publicBackflow2n3.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "107",
        title: "Backflow Manage Backflow Employer",
        label: "Backflow Manage Backflow Employer",
        value: "https://waterlink.utah.gov/secure/backflow/backflowEmployer.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "108",
        title: "Backflow System Authority Statement",
        label: "Backflow System Authority Statement",
        value: "https://waterlink.utah.gov/secure/backflow/systemAuthorityStatement.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "109",
        title: "Backflow Water System Manage Staff",
        label: "Backflow Water System Manage Staff",
        value: "https://waterlink.utah.gov/secure/backflow/backflowManageStaff.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "110",
        title: "DDW Administration Email Messages Admin",
        label: "DDW Administration Email Messages Admin",
        value: "https://waterlink.utah.gov/secure/admin/emailMessagesAdmin.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "293",
        title: "DDW Administration IPS Summary Report",
        label: "DDW Administration IPS Summary Report",
        value: "https://waterlink.utah.gov/secure/ess/admin/ipsSummaryReport.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "294",
        title: "DDW Administration 2020 Master Change Report",
        label: "DDW Administration 2020 Master Change Report",
        value: "https://waterlink.utah.gov/secure/ess/admin/masterChangeReport2020.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "295",
        title: "DDW Administration 2021 Master Change Report",
        label: "DDW Administration 2021 Master Change Report",
        value: "https://waterlink.utah.gov/secure/ess/admin/masterChangeReport2021.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "111",
        title: "DDW Administration Backflow Technician Certification Statistics Report",
        label: "DDW Administration Backflow Technician Certification Statistics Report",
        value: "https://waterlink.utah.gov/secure/reports/management/backflowCertificationStatisticsReport.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "112",
        title: "DDW Administration Operator Certification Statistics Report",
        label: "DDW Administration Operator Certification Statistics Report",
        value: "https://waterlink.utah.gov/secure/reports/management/operatorCertificationStatisticsReport.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "113",
        title: "DDW Administration Chemical Analysis Report",
        label: "DDW Administration Chemical Analysis Report",
        value: "https://waterlink.utah.gov/public/chemicalAnalysisReport.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "114",
        title: "DDW Administration Water System Statistics Report",
        label: "DDW Administration Water System Statistics Report",
        value: "https://waterlink.utah.gov/secure/reports/management/waterSystemStatReport.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "115",
        title: "DDW Administration PWS Water System Master Report",
        label: "DDW Administration PWS Water System Master Report",
        value: "https://waterlink.utah.gov/secure/reports/management/waterSystemMasterReport.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "116",
        title: "DDW Administration Unsolved Source Water Protection Deficiencies",
        label: "DDW Administration Unsolved Source Water Protection Deficiencies",
        value: "https://waterlink.utah.gov/secure/reports/management/sourceProtectionDefcy.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "117",
        title: "DDW Administration Global Mailing",
        label: "DDW Administration Global Mailing",
        value: "https://waterlink.utah.gov/secure/reports/globalMailing.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "118",
        title: "DDW Administration Confidential System Source Report",
        label: "DDW Administration Confidential System Source Report",
        value: "https://waterlink.utah.gov/secure/admin/confidentialSourceReport.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "119",
        title: "DDW Administration Manage System eDocs Links",
        label: "DDW Administration Manage System eDocs Links",
        value: "https://waterlink.utah.gov/secure/admin/casper/systemLinkFolder.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "120",
        title: "DDW Administration Active Facility Report",
        label: "DDW Administration Active Facility Report",
        value: "https://waterlink.utah.gov/secure/dynreport/viewReport.html?reportKey=ddw_admin_active_facility_report",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "121",
        title: "DDW Administration Emergency Response Tracking Stats Report",
        label: "DDW Administration Emergency Response Tracking Stats Report",
        value: "https://waterlink.utah.gov/portal/secure/ertReport.html",
        accessType: "secure-external",
        roles: "portal",
        moduleCode: "",
    },
    {
        id: "122",
        title: "DDW Administration Portal Account Admin",
        label: "DDW Administration Portal Account Admin",
        value: "https://waterlink.utah.gov/secure/admin/portal/searchPortalAccount.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "123",
        title: "DDW Administration Portal Water System Update Request",
        label: "DDW Administration Portal Water System Update Request",
        value: "https://waterlink.utah.gov/secure/admin/portal/inventory/manageInventoryChange.html",
        accessType: "secure-external",
        roles: "portal",
        moduleCode: "",
    },
    {
        id: "124",
        title: "DDW Administration System File Upload Approval",
        label: "DDW Administration System File Upload Approval",
        value: "https://waterlink.utah.gov/secure/admin/systemFileUploadAdmin.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "125",
        title: "DDW Administration Water System Metrics",
        label: "DDW Administration Water System Metrics",
        value: "https://waterlink.utah.gov/secure/reports/management/waterSystemMetrics.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "311",
        title: "DDW Administration Howler Notifications",
        label: "DDW Administration Howler Notifications",
        value: "https://waterlink.utah.gov/secure/reports/management/howlerNotifications.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "312",
        title: "DDW Administration Facility Exemption Variance and Exception Tracking",
        label: "DDW Administration Facility Exemption Variance and Exception Tracking",
        value: "https://waterlink.utah.gov/secure/facilityExceptionVarianceSearch.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "126",
        title: "DDW Administration Lead in Schools - Actions",
        label: "DDW Administration Lead in Schools - Actions",
        value: "https://waterlink.utah.gov/secure/dynreport/viewReport.html?reportKey=ddw_lead_school_actions",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "127",
        title: "DDW Administration Lead in Schools - Actions With Detail Data",
        label: "DDW Administration Lead in Schools - Actions With Detail Data",
        value: "https://waterlink.utah.gov/secure/dynreport/viewReport.html?reportKey=ddw_lead_school_actions_detail_data",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "128",
        title: "DDW Administration Lead in Schools - Actions Summary Data",
        label: "DDW Administration Lead in Schools - Actions Summary Data",
        value: "https://waterlink.utah.gov/secure/dynreport/viewReport.html?reportKey=ddw_lead_school_actions_data",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "316",
        title: "DDW Administration Lead in Schools - Data",
        label: "DDW Administration Lead in Schools - Data",
        value: "https://waterlink.utah.gov/secure/dynreport/viewReport.html?reportKey=ddw_lead_school_data",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "129",
       title: "DDW Administration Cost Recovery Fees Fee Admin",
       label: "DDW Administration Cost Recovery Fees Fee Admin",
       value: "https://waterlink.utah.gov/secure/admin/costRecoveryFeesAdmin.html",
       accessType: "secure-external",
       roles: "",
       moduleCode: "",
    },
    {
        id: "130",
        title: "DDW Administration FINET Fees CSV Export",
        label: "DDW Administration FINET Fees CSV Export",
        value: "https://waterlink.utah.gov/secure/admin/costRecoveryFeesReport.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "319",
        title: "DWQ Section Manage Water Body",
        label: "DWQ Section Manage Water Body",
        value: "https://waterlink.utah.gov/secure/dwq/hab/waterBodyMain.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "320",
        title: "DWQ Section Harmful Algal Bloom Tracking",
        label: "DWQ Section Harmful Algal Bloom Tracking",
        value: "https://waterlink.utah.gov/secure/dwq/hab/habMain.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "133",
        title: "Site Visits Admin Manage Site Visits",
        label: "Site Visits Admin Manage Site Visits",
        value: "https://waterlink.utah.gov/secure/ess/admin/manageSurvey.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "SV",
    },
    {
        id: "134",
        title: "Manage Mail and Lock Message",
        label: "Manage Mail and Lock Message",
        value: "https://waterlink.utah.gov/secure/ess/admin/manageMailAndLock.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "322",
        title: "Site Visits Admin 2020 Master Change Report",
        label: "Site Visits Admin 2020 Master Change Report",
        value: "https://waterlink.utah.gov/secure/ess/admin/masterChangeReport2020.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "SV",
    },
    {
        id: "323",
        title: "Site Visits Admin 2021 Master Change Report",
        label: "Site Visits Admin 2021 Master Change Report",
        value: "https://waterlink.utah.gov/secure/ess/admin/masterChangeReport2021.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "SV",
    },
    {
        id: "135",
        title: "Site Visits Admin 2021 Master Change Report Manage Level Two Email Message",
        label: "Site Visits Admin 2021 Master Change Report Manage Level Two Email Message",
        value: "https://waterlink.utah.gov/secure/ess/admin/levelTwoEmailBody.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "SV",
    },
    {
        id: "136",
        title: "Site Visits Admin 2021 Master Change Report Manage Section And Question",
        label: "Site Visits Admin 2021 Master Change Report Manage Section And Question",
        value: "https://waterlink.utah.gov/secure/ess/admin/manageQuestion.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "SV",
    },
    {
        id: "137",
        title: "Site Visits Admin2021 Master Change Report Manage Option Entries",
        label: "Site Visits Admin2021 Master Change Report Manage Option Entries",
        value: "https://waterlink.utah.gov/secure/ess/admin/manageOption.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "SV",
    },
    {
        id: "138",
        title: "Site Visits Admin 2021 Master Change Report Manage Section Conditions",
        label: "Site Visits Admin 2021 Master Change Report Manage Section Conditions",
        value: "https://waterlink.utah.gov/secure/ess/admin/manageCondition.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "SV",
    },
    {
        id: "139",
        title: "Site Visits Admin 2021 Master Change Report Manage Email Contacts",
        label: "Site Visits Admin 2021 Master Change Report Manage Email Contacts",
        value: "https://waterlink.utah.gov/secure/ess/admin/manageEmailContacts.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "SV",
    },
    {
        id: "140",
        title: "Site Visits Admin 2021 Master Change Report SQL Help and Reference",
        label: "Site Visits Admin 2021 Master Change Report SQL Help and Reference",
        value: "https://waterlink.utah.gov/secure/ess/admin/sqlHelp.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "SV",
    },
    {
        id: "141",
        title: "Site Visits Admin Manage LHD Survey Proposals",
        label: "Site Visits Admin Manage LHD Survey Proposals",
        value: "https://waterlink.utah.gov/secure/ess/admin/manageLhdSurveyProposals.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "SV",
    },
    {
        id: "142",
        title: "Site Visits Admin Status Report for Site Visits",
        label: "Site Visits Admin Status Report for Site Visits",
        value: "https://waterlink.utah.gov/secure/ess/admin/statusReport.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "SV",
    },
    {
        id: "143",
        title: "Site Visits Admin 30 Day Deadline Report",
        label: "Site Visits Admin 30 Day Deadline Report",
        value: "https://waterlink.utah.gov/secure/ess/admin/thirtyDayReport.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "SV",
    },
    {
        id: "144",
        title: "All Questions PDF",
        label: "All Questions PDF",
        value: "https://waterlink.utah.gov/portal/secure/surveyIndex.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "SV",
    },
    {
        id: "145",
        title: "Site Visits Admin Sanitary Survey Competency Manage Surveyor Competency Courses",
        label: "Site Visits Admin Sanitary Survey Competency Manage Surveyor Competency Courses",
        value: "https://waterlink.utah.gov/secure/ess/surveyorCompetency/manageSurveyorCompCourses.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "SV",
    },
    {
        id: "146",
        title: "Site Visits Admin Sanitary Survey Competency Surveyor Competency Tracking",
        label: "Site Visits Admin Sanitary Survey Competency Surveyor Competency Tracking",
        value: "https://waterlink.utah.gov/secure/ess/surveyorCompetency/surveyorSearchMain.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "SV",
    },
    {
        id: "147",
        title: "Site Visits Admin Sanitary Survey Competency Manage Competency Instructors",
        label: "Site Visits Admin Sanitary Survey Competency Manage Competency Instructors",
        value: "https://waterlink.utah.gov/secure/course/manageCeuInstructors.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "SV",
    },
    {
        id: "148",
        title: "Site Visits Admin Sanitary Survey Competency Manage Competency Categories",
        label: "Site Visits Admin Sanitary Survey Competency Manage Competency Categories",
        value: "https://waterlink.utah.gov/secure/course/manageCeuCategories.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "SV",
    },
    {
        id: "149",
        title: "Site Visits Sanitary Surveyor My Site Visits",
        label: "Site Visits Sanitary Surveyor My Site Visits",
        value: "https://waterlink.utah.gov/portal/secure/survey/mySurveys.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "SV",
    },
    {
        id: "338",
        title: "Site Visits Sanitary Surveyor 30 Day Deadline Report",
        label: "Site Visits Sanitary Surveyor 30 Day Deadline Report",
        value: "https://waterlink.utah.gov/secure/ess/admin/thirtyDayReport.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "SV",
    },
    {
        id: "151",
        title: "Site Visits Sanitary Surveyor Public Site Visits Status Report",
        label: "Site Visits Sanitary Surveyor Public Site Visits Status Report",
        value: "https://waterlink.utah.gov/portal/secure/survey/publicStatusReport.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "SV",
    },
    {
        id: "152",
        title: "Site Visits Sanitary Surveyor EZ Search (Past Site Visits)",
        label: "Site Visits Sanitary Surveyor EZ Search (Past Site Visits)",
        value: "http://eqedocs.utah.gov/",
        accessType: "secure-external",
        roles: "",
        moduleCode: "SV",
    },
    {
        id: "153",
        title: "Site Visits Sanitary Surveyor Capacity Spreadsheet",
        label: "Site Visits Sanitary Surveyor Capacity Spreadsheet",
        value: "https://documents.deq.utah.gov/drinking-water/engineering/DDW-2017-004386.xlsx",
        accessType: "secure-external",
        roles: "",
        moduleCode: "SV",
    },
    {
        id: "154",
        title: "CCC Program Administrator Schedule",
        label: "CCC Program Administrator Schedule",
        value: "https://documents.deq.utah.gov/drinking-water/field-services/DDW-2018-006969.pdf",
        accessType: "secure-external",
        roles: "",
        moduleCode: "",
    },
    {
        id: "342",
        title: "Site Visits Sanitary Surveyor Deficiency Resolution Form",
        label: "Site Visits Sanitary Surveyor Deficiency Resolution Form",
        value: "https://documents.deq.utah.gov/drinking-water/forms/DDW-2018-003072.pdf",
        accessType: "secure-external",
        roles: "",
        moduleCode: "SV",
    },
    {
        id: "343",
        title: "Site Visits Sanitary Surveyor CCC Program Administrator Schedule",
        label: "Site Visits Sanitary Surveyor CCC Program Administrator Schedule",
        value: "https://docs.google.com/spreadsheets/d/e/2PACX-1vTw-fmp8lqardecdMFPc0jc9Q0PY14PBIgmj1LnZvY7CS-W3tRo3c6lSPtDg5Lkcwj_UFjLHTYWjXN5/pubhtml?gid=119403658&single=true",
        accessType: "secure-external",
        roles: "",
        moduleCode: "SV",
    },
    {
        id: "155",
        title: "Site Visits Sanitary Surveyor BF 101 Training Online Version",
        label: "Site Visits Sanitary Surveyor BF 101 Training Online Version",
        value: "https://deq.utah.gov/drinking-water/backflow-101",
        accessType: "secure-external",
        roles: "",
        moduleCode: "SV",
    },
    {
        id: "156",
        title: "Site Visits Sanitary Surveyor Certified Cross Connection Program Administrators",
        label: "Site Visits Sanitary Surveyor Certified Cross Connection Program Administrators",
        value: "https://waterlink.utah.gov/public/publicBackflow1.html",
        accessType: "secure-external",
        roles: "",
        moduleCode: "SV",
    },
    {
        id: "157",
        title: "Site Visits Sanitary Surveyor BF 101 report PDF (as of June 2016) By Name",
        label: "Site Visits Sanitary Surveyor BF 101 report PDF (as of June 2016) By Name",
        value: "https://documents.deq.utah.gov/drinking-water/field-services/DDW-2018-004886.pdf",
        accessType: "secure-external",
        roles: "",
        moduleCode: "SV",
    },
    {
        id: "158",
        title: "Site Visits Sanitary Surveyor BF 101 report PDF (as of June 2016) By System",
        label: "Site Visits Sanitary Surveyor BF 101 report PDF (as of June 2016) By System",
        value: "https://documents.deq.utah.gov/drinking-water/field-services/DDW-2018-005123.pdf",
        accessType: "secure-external",
        roles: "",
        moduleCode: "SV",
    },
    {
        id: "159",
        title: "Site Visits Sanitary Surveyor Exceptions - by LHD Spreadsheet (as of 5/7/2018)",
        label: "Site Visits Sanitary Surveyor Exceptions - by LHD Spreadsheet (as of 5/7/2018)",
        value: "https://documents.deq.utah.gov/drinking-water/field-services/DDW-2018-004887.xlsx",
        accessType: "secure-external",
        roles: "",
        moduleCode: "SV",
    },
    {
        id: "349",
        title: "Site Visits Sanitary Surveyor Source Protection Report for Surveyors",
        label: "Site Visits Sanitary Surveyor Source Protection Report for Surveyors",
        value: "https://documents.deq.utah.gov/drinking-water/field-services/DDW-2018-005401.xlsx",
        accessType: "secure-external",
        roles: "",
        moduleCode: "SV",
    },
    {
        id: "350",
        title: "Loan Tracker",
        label: "Loan Tracker",
        value: "https://waterlink.utah.gov/loanTracker/dashboard",
        accessType: "secure-external",
        roles: "",
        moduleCode: "SV",
    },
  ];
